// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from 'vue'

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // Look for files in the current directory
  '.',
  // Look in subdirectories
  true,
  // Only include "_base-" prefixed .vue files
  /_base-[\w-]+\.vue$/
)

const requireFabricComponent = require.context(
  // Look for files in the current directory
  './fabric',
  // Look in subdirectories
  true,
)

const handleDependencies = [
  {
    handle: requireComponent,
  },
  {
    handle: requireFabricComponent,
    prefix: 'Fabric',
  },
]


handleDependencies.map(handleDependency => {
  const { handle } = handleDependency
  // For each matching file name...
  handle.keys().forEach((fileName) => {
    // Get the component config
    const componentConfig = handle(fileName)
    // Get the PascalCase version of the component name
    let componentName = fileName
      // get file name ignore subdirectories
      .split('/').pop()
      // Remove the "_" from the beginning
      .replace(/^_/, '')
      // Remove the file extension from the end
      .replace(/\.\w+$/, '')
      // Split up kebabs
      .split('-')
      // Upper case
      .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
      // Concatenated
      .join('')

    if (handleDependency?.prefix?.length > 2) {
      componentName = `${handleDependency.prefix}${componentName}`
    }

    // Globally register the component
    Vue.component(componentName, componentConfig.default || componentConfig)
  })
  return handleDependency
})

require('./plugins')
